import React, { useState } from 'react';
import generateExcelFile from './xlsxArrearsSeventh';
import { Download, Loader2 } from 'lucide-react';  // Use same icon set for consistency

const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const formatFileName = (employeeName) => {
  const formattedDate = formatDate(new Date());
  return `Arrears_Seventh_${employeeName}_${formattedDate}.xlsx`;
};

const InteractiveExcelWrapper = ({ result, info }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadExcel = async () => {
    try {
      setIsLoading(true);
      const excelBlob = await generateExcelFile(result, info);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(excelBlob);
      link.download = formatFileName(info.employeeName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error generating Excel file:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={downloadExcel}
      disabled={isLoading}
      className={`flex-1 w-full flex items-center justify-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5 rounded-md transition-all
        ${isLoading
          ? 'bg-gray-100 text-gray-600 cursor-not-allowed'
          : 'bg-green-600 text-white hover:bg-green-700 shadow-sm'
        } text-sm font-medium`}
      aria-label="Download Excel File"
      title="Download Excel File"
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <>
          <Download className="h-4 w-4" />
          <span className="hidden sm:inline">Download Excel</span>
          <span className="sm:hidden">Download</span>
        </>
      )}
    </button>
  );
};

export default InteractiveExcelWrapper;
